export const industries = [
  {
    id: "healthcare",
    name: "Healthcare",
    icon: "Heart",
    color: "text-rose-600",
    bgColor: "bg-rose-50",
    borderColor: "border-rose-200",
    featured: true,
    segments: [
      { name: "Hospitals", pain: "Doctors waste 2hrs/day writing notes manually", solution: "AI-powered clinical note generation from voice" },
      { name: "Clinics", pain: "Patients forget medicines & follow-up appointments", solution: "Automated reminders & medication tracking" },
      { name: "Pharmacies", pain: "Drug interaction checks done manually, slow & risky", solution: "AI drug interaction screening in real-time" },
      { name: "Dental Clinics", pain: "Treatment plans typed from scratch every time", solution: "Auto-generated treatment plans from diagnosis" },
      { name: "Eye Clinics", pain: "Prescription records managed on paper", solution: "Digital prescription management with AI insights" },
      { name: "Physiotherapy", pain: "Progress notes written manually after every session", solution: "Automated session summaries and progress tracking" },
      { name: "Veterinary Clinics", pain: "Discharge summaries typed manually per animal", solution: "AI discharge summary generation" }
    ]
  },
  {
    id: "legal",
    name: "Legal",
    icon: "Scale",
    color: "text-amber-700",
    bgColor: "bg-amber-50",
    borderColor: "border-amber-200",
    featured: true,
    segments: [
      { name: "Law Firms", pain: "Drafting repetitive contracts wastes junior lawyer hours", solution: "AI contract generation from structured inputs" },
      { name: "Notaries", pain: "Document verification tracked on paper registers", solution: "Digital verification & tracking system" },
      { name: "IP Firms", pain: "Patent research done manually across 100s of documents", solution: "AI-powered patent search & analysis" },
      { name: "Divorce Lawyers", pain: "Same petition templates retyped for every client", solution: "Smart petition drafting from case data" },
      { name: "Property Lawyers", pain: "Title deed verification is slow and manual", solution: "Automated title deed verification" }
    ]
  },
  {
    id: "education",
    name: "Education",
    icon: "GraduationCap",
    color: "text-blue-600",
    bgColor: "bg-blue-50",
    borderColor: "border-blue-200",
    featured: true,
    segments: [
      { name: "Engineering Colleges", pain: "Placement team manually matches students to companies", solution: "AI matching engine for optimal placements" },
      { name: "Schools (K-12)", pain: "Report cards written manually for 500+ students", solution: "Auto-generated personalized report cards" },
      { name: "Coaching Centers", pain: "Doubt resolution depends entirely on teacher availability", solution: "AI doubt-resolution chatbot available 24/7" },
      { name: "MBA Colleges", pain: "Case study feedback written individually by professors", solution: "AI-assisted feedback generation" },
      { name: "EdTech Platforms", pain: "Personalized learning paths don't exist", solution: "AI-driven adaptive learning paths" }
    ]
  },
  {
    id: "hospitality",
    name: "Hospitality",
    icon: "Hotel",
    color: "text-violet-600",
    bgColor: "bg-violet-50",
    borderColor: "border-violet-200",
    featured: false,
    segments: [
      { name: "Hotels", pain: "Guest questions answered manually by front desk 24/7", solution: "AI concierge chatbot for instant guest support" },
      { name: "Resorts", pain: "Reviews on Google/TripAdvisor go unresponded for days", solution: "Automated review response & sentiment analysis" },
      { name: "Hostels", pain: "Check-in/check-out process is entirely manual", solution: "Self-service digital check-in system" },
      { name: "Wedding Venues", pain: "Quotations and packages explained repeatedly", solution: "Interactive AI-powered package configurator" },
      { name: "Event Management", pain: "Vendor coordination tracked on WhatsApp chats", solution: "Centralized vendor management with AI scheduling" }
    ]
  },
  {
    id: "retail",
    name: "Retail & Supermarkets",
    icon: "ShoppingCart",
    color: "text-emerald-600",
    bgColor: "bg-emerald-50",
    borderColor: "border-emerald-200",
    featured: true,
    segments: [
      { name: "Supermarkets", pain: "Expired products cause monthly losses due to poor tracking", solution: "AI expiry tracking & automated alerts" },
      { name: "Kirana Stores", pain: "Reorder decisions made by gut feel, not data", solution: "Data-driven reorder recommendations" },
      { name: "Fashion Retail", pain: "Slow-moving stock identified too late", solution: "Predictive inventory analytics" },
      { name: "Electronics Stores", pain: "Warranty tracking done manually per customer", solution: "Automated warranty management system" },
      { name: "Medical Stores", pain: "Stock expiry and reorder managed on paper", solution: "AI inventory & compliance management" }
    ]
  },
  {
    id: "food",
    name: "Food & Beverage",
    icon: "UtensilsCrossed",
    color: "text-orange-600",
    bgColor: "bg-orange-50",
    borderColor: "border-orange-200",
    featured: false,
    segments: [
      { name: "Restaurants", pain: "Customer feedback collected but never acted on", solution: "AI feedback analysis with actionable insights" },
      { name: "Cloud Kitchens", pain: "Ingredient waste not tracked, margin leaks daily", solution: "AI waste tracking & margin optimization" },
      { name: "Bakeries", pain: "Daily production planning done manually", solution: "Demand-forecasting production planner" },
      { name: "Catering Companies", pain: "Menu planning and costing recalculated from scratch", solution: "AI menu planner with auto-costing" },
      { name: "Food Trucks", pain: "No system to track best-selling items by location", solution: "Location-based sales analytics" }
    ]
  },
  {
    id: "construction",
    name: "Construction & Real Estate",
    icon: "Building2",
    color: "text-slate-700",
    bgColor: "bg-slate-50",
    borderColor: "border-slate-200",
    featured: false,
    segments: [
      { name: "Builders", pain: "Weekly site progress reports take 3+ hours", solution: "AI auto-generated progress reports from photos" },
      { name: "Real Estate Agents", pain: "Property listings written poorly", solution: "AI listing generator with SEO optimization" },
      { name: "Interior Designers", pain: "Client proposals and mood boards made manually", solution: "AI-assisted proposal & mood board generator" },
      { name: "Architects", pain: "Client revision requests tracked over WhatsApp", solution: "Centralized project revision tracking" },
      { name: "Contractors", pain: "Material requirement planning done on paper", solution: "AI material planning & cost estimation" }
    ]
  },
  {
    id: "manufacturing",
    name: "Manufacturing & SMEs",
    icon: "Factory",
    color: "text-indigo-600",
    bgColor: "bg-indigo-50",
    borderColor: "border-indigo-200",
    featured: false,
    segments: [
      { name: "Small Factories", pain: "Quotations prepared manually, take 1-2 days", solution: "Instant AI-powered quotation generator" },
      { name: "Exporters", pain: "Shipping documentation errors cause delays", solution: "Automated shipping document preparation" },
      { name: "Traders", pain: "Follow-up on leads forgotten, deals lost", solution: "AI lead tracking & follow-up reminders" },
      { name: "Distributors", pain: "Route planning for delivery staff done manually", solution: "AI route optimization system" },
      { name: "Packaging Companies", pain: "Quality check reports filled on paper forms", solution: "Digital quality check with AI analysis" }
    ]
  },
  {
    id: "automotive",
    name: "Automotive",
    icon: "Car",
    color: "text-red-600",
    bgColor: "bg-red-50",
    borderColor: "border-red-200",
    featured: false,
    segments: [
      { name: "Car Dealerships", pain: "Sales leads followed up manually, inconsistently", solution: "AI-powered CRM with smart follow-ups" },
      { name: "Garages & Service Centers", pain: "Service reminder calls made manually", solution: "Automated service reminders & booking" },
      { name: "Driving Schools", pain: "Student progress tracked in notebooks", solution: "Digital progress tracking with AI insights" },
      { name: "Car Rentals", pain: "Vehicle availability managed over phone calls", solution: "Real-time availability & booking system" },
      { name: "Spare Parts Shops", pain: "Inventory tracked on paper", solution: "AI inventory management & order prediction" }
    ]
  },
  {
    id: "finance",
    name: "Finance & Accounting",
    icon: "Calculator",
    color: "text-teal-700",
    bgColor: "bg-teal-50",
    borderColor: "border-teal-200",
    featured: true,
    segments: [
      { name: "CA Firms", pain: "Chasing clients for documents done manually", solution: "Automated document collection workflows" },
      { name: "Tax Consultants", pain: "Explaining GST rules takes hours per client", solution: "AI tax advisor chatbot for client queries" },
      { name: "Insurance Agents", pain: "Policy renewal reminders sent manually", solution: "Automated renewal tracking & reminders" },
      { name: "Microfinance Companies", pain: "Loan repayment follow-up done manually", solution: "AI-powered repayment tracking & alerts" },
      { name: "Chartered Accountants", pain: "Compliance deadlines tracked on Excel", solution: "AI compliance calendar with auto-reminders" }
    ]
  },
  {
    id: "agriculture",
    name: "Agriculture",
    icon: "Sprout",
    color: "text-green-700",
    bgColor: "bg-green-50",
    borderColor: "border-green-200",
    featured: false,
    segments: [
      { name: "Farms", pain: "Pest identification requires expert visit, takes days", solution: "AI image-based pest & disease detection" },
      { name: "Agri Input Shops", pain: "Generic advice regardless of crop/soil", solution: "AI-personalized crop advisory" },
      { name: "Dairy Farms", pain: "Cattle health records maintained in registers", solution: "Digital health monitoring & records" },
      { name: "Cold Storage Units", pain: "Temperature logs maintained manually", solution: "IoT + AI temperature monitoring" },
      { name: "Agri Exporters", pain: "Compliance documents filled manually", solution: "Automated export compliance documentation" }
    ]
  },
  {
    id: "wellness",
    name: "Health & Wellness",
    icon: "Dumbbell",
    color: "text-pink-600",
    bgColor: "bg-pink-50",
    borderColor: "border-pink-200",
    featured: false,
    segments: [
      { name: "Gyms", pain: "40% of members quit in 90 days", solution: "AI churn prediction & engagement system" },
      { name: "Yoga Studios", pain: "Schedules communicated over WhatsApp", solution: "Digital scheduling & booking system" },
      { name: "Nutrition Clinics", pain: "Diet plans made manually for each client", solution: "AI-generated personalized diet plans" },
      { name: "Spas & Salons", pain: "Appointment booking via calls, no-shows frequent", solution: "Online booking with AI no-show prediction" },
      { name: "Mental Health Clinics", pain: "Session notes written manually", solution: "AI session note summarization" }
    ]
  },
  {
    id: "logistics",
    name: "Logistics & Supply Chain",
    icon: "Truck",
    color: "text-cyan-700",
    bgColor: "bg-cyan-50",
    borderColor: "border-cyan-200",
    featured: true,
    segments: [
      { name: "Courier Companies", pain: "Delivery updates sent manually or not at all", solution: "Automated real-time delivery tracking" },
      { name: "Warehouses", pain: "Inventory reconciliation done manually", solution: "AI inventory management & reconciliation" },
      { name: "Fleet Operators", pain: "Fuel expense tracking per vehicle on paper", solution: "AI fleet analytics & fuel optimization" },
      { name: "Last-Mile Delivery", pain: "Route assignment done manually each day", solution: "AI route optimization & assignment" },
      { name: "Cold Chain Logistics", pain: "Temperature compliance logs on paper", solution: "Automated compliance monitoring & alerts" }
    ]
  },
  {
    id: "government",
    name: "Government & Public Services",
    icon: "Landmark",
    color: "text-blue-800",
    bgColor: "bg-blue-50",
    borderColor: "border-blue-200",
    featured: false,
    segments: [
      { name: "Municipal Offices", pain: "Citizen complaint status communicated manually", solution: "AI-powered complaint tracking portal" },
      { name: "RTO Offices", pain: "Document verification queue managed manually", solution: "Automated queue & document verification" },
      { name: "Public Hospitals", pain: "Patient queue management done manually", solution: "AI-driven patient flow management" },
      { name: "Govt Schools", pain: "Mid-day meal attendance tracked on paper", solution: "Digital attendance & meal tracking" },
      { name: "Panchayat Offices", pain: "Land record queries handled manually", solution: "AI-powered land record search system" }
    ]
  },
  {
    id: "media",
    name: "Media & Marketing",
    icon: "Megaphone",
    color: "text-fuchsia-600",
    bgColor: "bg-fuchsia-50",
    borderColor: "border-fuchsia-200",
    featured: false,
    segments: [
      { name: "Digital Agencies", pain: "Monthly reports compiled from 5 different tools", solution: "AI unified reporting dashboard" },
      { name: "PR Firms", pain: "Media coverage tracking done manually", solution: "AI media monitoring & analysis" },
      { name: "Influencer Agencies", pain: "Campaign performance tracked on spreadsheets", solution: "AI campaign analytics platform" },
      { name: "Printing Companies", pain: "Job order status communicated manually", solution: "Automated order tracking & notifications" },
      { name: "Photography Studios", pain: "Photo delivery & feedback tracked on WhatsApp", solution: "Digital delivery & feedback portal" }
    ]
  },
  {
    id: "religious",
    name: "Religious & Community",
    icon: "Users",
    color: "text-yellow-700",
    bgColor: "bg-yellow-50",
    borderColor: "border-yellow-200",
    featured: false,
    segments: [
      { name: "Temples/Churches/Mosques", pain: "Donation records in physical books", solution: "Digital donation management system" },
      { name: "NGOs", pain: "Beneficiary data collected on paper forms", solution: "AI-powered beneficiary data platform" },
      { name: "Community Halls", pain: "Booking managed over phone calls", solution: "Online booking & availability system" },
      { name: "Trusts", pain: "Expense reporting done manually", solution: "Automated financial reporting" },
      { name: "Old Age Homes", pain: "Health records kept on paper", solution: "Digital health monitoring & records" }
    ]
  },
  {
    id: "telecom",
    name: "Telecom & IT Services",
    icon: "Wifi",
    color: "text-sky-600",
    bgColor: "bg-sky-50",
    borderColor: "border-sky-200",
    featured: false,
    segments: [
      { name: "ISPs", pain: "Customer complaint resolution tracked manually across teams", solution: "AI-powered ticket routing & resolution" },
      { name: "IT Service Companies", pain: "Project status updates compiled manually for clients", solution: "Automated project reporting & dashboards" },
      { name: "Data Centers", pain: "Server health monitoring requires manual log checking", solution: "AI predictive monitoring & alerting" },
      { name: "Managed Service Providers", pain: "SLA compliance tracked on spreadsheets", solution: "Automated SLA monitoring & alerts" },
      { name: "Software Companies", pain: "Bug triage and prioritization done manually", solution: "AI-powered bug classification & routing" }
    ]
  }
];
